import { IconContent } from '@icons';

export const workflow: IconContent = {
    md: '<path d="M2.5 5.5A2 2 0 0 1 6.437 5H21.5v7.5h-4.293l1.147 1.146-.708.708-2-2-.353-.354.353-.354 2-2 .708.708-1.147 1.146H20.5V6H6.437A2 2 0 0 1 2.5 5.5Zm15 13a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-7.437-6H3.5V18h10.793l-1.147-1.146.708-.708 2 2 .353.354-.353.354-2 2-.708-.708L14.293 19H2.5v-7.5h7.563a2 2 0 1 1 0 1Z" />',
};
